import { selector } from 'recoil';
import yardList from 'recoil/atoms/yardList';


const mainLoadingYardList = selector({
    key: 'mainLoadingYardList',
    get: ({get}) => {
        return get(yardList)
            .filter(y => !y.deletedAt && y.port.isLoading && !y.isDock);
    },
});

export default mainLoadingYardList;
